import React, { useState } from 'react';
import { SectionHeader } from '../../../partner-pages/utils/section-header';
import { ButtonWithAnchor } from '../hero-section/sticky-button';
import { ButtonVariants } from '../../../Atoms/Button';
import { ViewNewPlanModalContent } from '../hero-section/view-new-plan-modal-content';
import { MarktechModal } from '../../../Atoms/Modal';
import { FILING_LINK, startFilingLinkViewPlans } from '../../static/data';
import { ApiPlan } from '../hero-section/view-new-plan-modal-content/types';
import get from 'lodash.get';
import { bitwiseRoundOff } from '../../../Utils/CommonUtils';

const StartFilingSection = ({ plans }: { plans?: ApiPlan[] }) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const togglePlanModal = () => setIsPopupVisible(!isPopupVisible);
  const capitalGainPlanData =
    plans?.filter((plan) => plan.id === 'salary-income-plan') || [];
  const discountedPriceValue = Number(
    get(capitalGainPlanData[0], 'incomeBrackets[0].discountedAmount', '0')
  );
  const listPrice = Number(
    get(capitalGainPlanData[0], 'incomeBrackets[0].originalAmount', '0')
  );
  return (
    <div className="bg-brand-200 relative">
      <div className="py-40 px-20 wg-container overflow-clip lg:pb-24">
        <div
          className="pt-30 pl-16 bg-white rounded-3xl relative"
          style={{
            backgroundImage: `url('https://assets.clear.in/cleartax/images/1757316853_vector.svg')`,
            backgroundPosition: 'right center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div
            className="absolute top-0 left-[70px] text-base font-normal py-2 px-6 text-white rounded-b-lg"
            style={{
              background:
                'linear-gradient(162.11deg, #448C5A 33.14%, #0E4E22 117.54%)',
            }}
          >
            Plans start at just{' '}
            <span className="font-bold text-s-24">
              ₹{bitwiseRoundOff(discountedPriceValue)}
            </span>{' '}
            <span className="line-through">₹{bitwiseRoundOff(listPrice)}</span>
          </div>
          <SectionHeader
            heading={'Start filing now, pay later!'}
            align="left"
            description="We'll auto select your plan basis on your ITR info. Pay later at checkout"
            className="font-semibold text-s-46"
            descriptionClassName="font-normal text-base pb-8"
          />
          <div className="flex w-2/5 gap-3 pb-20">
            <ButtonWithAnchor
              buttonText={'File now in 3 mins'}
              trackLabel={'in_page'}
              buttonVariant={ButtonVariants.bluefilled}
              buttonLink={FILING_LINK}
            />
            <ButtonWithAnchor
              buttonText={'Explore Plans'}
              trackLabel={'in_page'}
              buttonVariant={ButtonVariants.bluebordered}
              onClickHandler={() => togglePlanModal()}
            />
            <MarktechModal
              open={isPopupVisible}
              onClose={togglePlanModal}
              closeIcon={'✕'}
              classNames={{
                modal:
                  'mobile-search-box rounded-2xl md:w-11/12 sm:w-11/12 h-fit max-h-[90vh] overflow-hidden maxWidth',
                closeIcon: 'absolute',
              }}
              center
            >
              <div
                className="modal rounded-xl modal-open bg-[#EEF5FF]  w-full"
                id="contact-sales"
                data-fold-location="navbar_button_Book a demo"
              >
                <ViewNewPlanModalContent
                  trackLabel="test-label"
                  plansList={plans || []}
                  buttonLink={startFilingLinkViewPlans}
                />
              </div>
            </MarktechModal>
          </div>
        </div>
      </div>
      <img
        src="https://assets.clear.in/cleartax/images/1757765735_frame2147224655.png"
        alt="start_filing_now_pay_later"
        className="absolute -translate-y-full right-0 lg:h-[450px] h-[630px]"
        loading="lazy"
        width="450"
        height="630"
      />
    </div>
  );
};

export default StartFilingSection;
